import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, PLATFORM_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule, RouteReuseStrategy } from '@angular/router';
import { AppRouteReuseStrategy } from './core/services/app-route-reuse-strategy';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { CoreModule } from './core/core.module';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { isPlatformBrowser } from '@angular/common';
import { Library } from './core/library';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { LocalStorageService } from './core/services/local.storage.service';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/error.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { AboutComponent } from './components/about/about.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PlanPagesComponent } from './plan-pages/plan-pages.component';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { EPaymentPlanComponent } from './e-payment-plan/e-payment-plan.component';
import { BillPagesComponent } from './bill-pages/bill-pages.component';
import { SessionTimeoutPageComponent } from './session-timeout-page/session-timeout-page.component';
import { MatIconModule } from '@angular/material/icon';
import { SssAlphalistReportComponent } from './admin-pages/sss-alphalist-report/sss-alphalist-report.component';
import { InActivePageComponent } from './in-active-page/in-active-page.component';
import { ClientRegistrationComponent } from './admin-pages/client-registration/client-registration.component';
import { VerifiedPageComponent } from './auth-pages/verified-page/verified-page.component';
import { ServerErrorPageComponent } from './server-error-page/server-error-page.component';
import { ServerErrorInterceptor } from './core/guards/server-error';
import { LeaveReportComponent } from './admin-pages/leave-report/leave-report.component';
import { WorkAttendanceLogComponent } from './admin-pages/work-attendance-log/work-attendance-log.component';
import { BirGenerationComponent } from './admin-pages/bir-generation/bir-generation.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    NgbModule,
    MatDialogModule,
    ToastrModule.forRoot(),
    CoreModule.forRoot(),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [PLATFORM_ID]
      }
    }),
    FontAwesomeModule,
    MatIconModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    AboutComponent,
    PlanPagesComponent,
    MaintenancePageComponent,
    EPaymentPlanComponent,
    BillPagesComponent,
    SessionTimeoutPageComponent,
    InActivePageComponent,
    VerifiedPageComponent,
    ServerErrorPageComponent,
  ],
  providers: [
    LocalStorageService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
    CookieService,
    AppRouteReuseStrategy,
    { provide: RouteReuseStrategy, useExisting: AppRouteReuseStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function jwtOptionsFactory(platformId: any) {
  return {
    tokenGetter: () => {
      let token = null;
      if (isPlatformBrowser(platformId)) {
        token = localStorage.getItem('jwt');
        // token = this.cookieService.get('jwt');
      }
      return token;
    },
    whitelistedDomains: [Library.API_DOMAIN]
  };
}